<script setup>
  import { defineProps, computed } from 'vue'
  import TypeBadge from "../TypeBadge.vue"

  const props = defineProps({
    acw: {
      type: Boolean,
      default: false
    },
    flipped: {
      type: Boolean,
      default: false
    },
    data: Array,
  })

  const direction = computed(()=>{
    if ((props.acw && !props.flipped) || (!props.acw && props.flipped)){
      return 'left'
    }
    return 'right'
  })

</script>
<template>
  <div :class="[
    props.acw ? 'acw' : 'cw',
    'text-'+direction
]">

    <template v-if="direction=='left'">&larr;</template>

    <div class="damage inline-block py-1 px-2">
        <TypeBadge :type-id="props.data[0][0]"/>
        {{props.data[0][1]}}&times;
    </div>

    <div
      v-if="props.data[1][0] != '-' && props.data[1][0] != props.data[0][0]"
      class="damage inline-block py-1 px-2"
    >
        <TypeBadge :type-id="props.data[1][0]"/>
        {{props.data[1][1]}}&times;
    </div>

    <template v-if="direction=='right'">&rarr;</template>
  </div>
</template>
